import { Box, Stack, ThemeTypings } from "@chakra-ui/react";
import React, { ReactElement, ReactNode } from "react";

export interface InspectorBoxProps {
  py?: ThemeTypings["space"];
  pt?: ThemeTypings["space"];
  pb?: ThemeTypings["space"];
  children: ReactNode;
}

export default function InspectorBox(props: InspectorBoxProps): ReactElement {
  const { py, pt, pb, children } = props;

  return (
    <Box w="100%" py={py} pt={pt} pb={pb} pointerEvents="all" borderRadius="md">
      <Stack spacing="4" w="100%">
        {children}
      </Stack>
    </Box>
  );
}
